import { render, staticRenderFns } from "./ContractAdditionalInformation.vue?vue&type=template&id=010bead3"
import script from "./ContractAdditionalInformation.vue?vue&type=script&lang=js"
export * from "./ContractAdditionalInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports